export function ExamplePrompt(props) {
	return (
		<div className={"border w-100 p-2 px-4 rounded-medium hover:cursor-pointer " + (props.className ?? "")} onClick={() => {
			props.submitMessage(props.children);
		}}>
			<p className="mb-0">{props.children}</p>
		</div>
		
  );
}